"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { Button } from "@/components/ui/button";
import { AlertCircle, RefreshCw, Home } from "lucide-react";
import Link from "next/link";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    Sentry.captureException(error);
    console.error("Bir hata olustu:", error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-16">
      <div className="mx-auto max-w-md text-center">
        {/* Hata İkonu */}
        <div className="mb-6 flex justify-center">
          <div className="bg-destructive/10 rounded-full p-4">
            <AlertCircle className="text-destructive h-12 w-12" />
          </div>
        </div>

        {/* Başlık */}
        <h1 className="text-foreground mb-2 text-2xl font-bold">Bir Şeyler Yanlış Gitti</h1>

        {/* Açıklama */}
        <p className="text-muted-foreground mb-6">
          Üzgünüz, beklenmeyen bir hata oluştu. Lütfen sayfayı yenilemeyi deneyin veya ana sayfaya
          dönün.
        </p>

        {/* Hata Detayı (Development modda) */}
        {process.env.NODE_ENV === "development" && error.message && (
          <div className="bg-muted mb-6 rounded-lg p-4 text-left">
            <p className="text-muted-foreground font-mono text-sm">{error.message}</p>
            {error.digest && (
              <p className="text-muted-foreground mt-2 text-xs">Hata Kodu: {error.digest}</p>
            )}
          </div>
        )}

        {/* Aksiyonlar */}
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button onClick={reset} variant="default" className="gap-2">
            <RefreshCw className="h-4 w-4" />
            Tekrar Dene
          </Button>
          <Button asChild variant="outline" className="gap-2">
            <Link href="/">
              <Home className="h-4 w-4" />
              Ana Sayfaya Dön
            </Link>
          </Button>
        </div>

        {/* Destek Linki */}
        <p className="text-muted-foreground mt-8 text-sm">
          Sorun devam ederse{" "}
          <Link href="/about#iletisim" className="text-primary hover:underline">
            bizimle iletişime geçin
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
